// Use local calendar dates, never UTC conversion, for these preview-only periods.
export const SAMPLE_AWARD_PERIOD = { start: '2026-10-01', end: '2026-10-31' };

export function parsePeriodDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return undefined;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day, 12);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : undefined;
}

export function periodDateValue(date) {
  return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function monthPeriod(month) {
  const start = parsePeriodDate(`${month}-01`);
  return start ? { start: periodDateValue(start), end: periodDateValue(new Date(start.getFullYear(), start.getMonth() + 1, 0, 12)) } : undefined;
}

export function validPeriod(period) {
  return !!(parsePeriodDate(period?.start) && parsePeriodDate(period?.end) && period.start <= period.end);
}

export function formatAwardPeriod(period) {
  if (!validPeriod(period)) return '';
  const start = parsePeriodDate(period.start), end = parsePeriodDate(period.end);
  const month = date => date.toLocaleDateString('en-US', { month: 'long' });
  if (period.start === period.end) return `${month(start)} ${start.getDate()}, ${start.getFullYear()}`;
  if (start.getFullYear() === end.getFullYear()) {
    return start.getMonth() === end.getMonth()
      ? `${month(start)} ${start.getDate()}–${end.getDate()}, ${end.getFullYear()}`
      : `${month(start)} ${start.getDate()}–${month(end)} ${end.getDate()}, ${end.getFullYear()}`;
  }
  return `${month(start)} ${start.getDate()}, ${start.getFullYear()}–${month(end)} ${end.getDate()}, ${end.getFullYear()}`;
}
